import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default ({
  user,
  domain,
  board,
}) => new Promise((resolve) => {
  nsApi.get({
    object: 'dashboard',
    action: 'delete',
    domain,
    user,
    id: board.id,
  }).then(() => {
    resolve(true);
  }).catch((err) => {
    console.error(err);
    resolve(false);
  });
});
